import { render, staticRenderFns } from "./EventTabReportUpdateDialog.vue?vue&type=template&id=299fb31c&"
import script from "./EventTabReportUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./EventTabReportUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports